import Initializer, { resetIsInitialLoad } from './Initializer';

export { resetIsInitialLoad };
export default Initializer;
